module.exports = __webpack_public_path__ + "img/border-bottom.635937d8.png";